import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const Home = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState({ total_members: 0, total_countries: 0 });

  useEffect(() => {
    axios.get(`${API}/public/stats`).then(r => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="home-page">
      <SEO path="/" title="Home" description="AFHOS unites national societies, researchers, and health partners to prevent and control high blood pressure across Africa through collaboration, innovation, and evidence-based action." />
      <section className="hero">
        <p className="overline" style={{ color: 'rgba(255,255,255,0.85)' }}>{t('home.established')}</p>
        <h1 data-testid="hero-title">{t('home.title')}</h1>
        <p className="lead" data-testid="hero-description">{t('home.subtitle')}</p>
        <div style={{ marginTop: '2rem', display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/about" className="btn" data-testid="discover-button">{t('home.discover')}</Link>
          <Link to="/auth" className="btn btn-secondary" data-testid="join-button">{t('home.join')}</Link>
        </div>
      </section>

      {/* Live member count CTA */}
      {(
        <div className="member-cta" data-testid="member-count-widget">
          <i className="fas fa-users"></i>
          <span>{t('home.joinCta', { count: (18442 + (stats.total_members || 0)).toLocaleString() })}</span>
        </div>
      )}

      <section className="grid-3">
        <article className="card" data-testid="home-card-mission">
          <p className="overline">{t('home.missionOverline')}</p>
          <h3>{t('home.missionTitle')}</h3>
          <p style={{ color: 'var(--muted)' }}>{t('home.missionDesc')}</p>
        </article>
        <article className="card" data-testid="home-card-news">
          <p className="overline">{t('home.newsOverline')}</p>
          <h3>{t('home.newsTitle')}</h3>
          <p style={{ color: 'var(--muted)' }}>{t('home.newsDesc')}</p>
          <Link to="/news" className="btn btn-secondary btn-small" style={{ marginTop: '1rem' }} data-testid="read-news-link">{t('home.readNews')}</Link>
        </article>
        <article className="card" data-testid="home-card-events">
          <p className="overline">{t('home.eventsOverline')}</p>
          <h3>{t('home.eventsTitle')}</h3>
          <p style={{ color: 'var(--muted)' }}>{t('home.eventsDesc')}</p>
          <Link to="/events" className="btn btn-secondary btn-small" style={{ marginTop: '1rem' }} data-testid="view-events-link">{t('home.viewEvents')}</Link>
        </article>
      </section>

      <section style={{ margin: '3rem 0', padding: '2.5rem', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: '0.75rem' }}>
        <div style={{ textAlign: 'center', maxWidth: '700px', margin: '0 auto' }}>
          <p className="overline">{t('home.resourcesOverline')}</p>
          <h2 style={{ marginBottom: '0.75rem', fontSize: '1.75rem' }}>{t('home.resourcesTitle')}</h2>
          <p style={{ color: 'var(--muted)', marginBottom: '2rem' }}>{t('home.resourcesDesc')}</p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/cms" className="btn btn-secondary" data-testid="documents-link">{t('home.docLibrary')}</Link>
            <Link to="/workspace" className="btn btn-secondary" data-testid="members-link">{t('home.memberDir')}</Link>
            <Link to="/projects" className="btn btn-secondary" data-testid="projects-link">{t('home.researchProjects')}</Link>
          </div>
        </div>
      </section>

      <section className="grid-3" style={{ marginBottom: '2rem' }}>
        {[
          { value: '54', label: t('home.statNations') },
          { value: '200M+', label: t('home.statAffected') },
          { value: stats.total_members > 0 ? stats.total_members : '10+', label: stats.total_members > 0 ? t('home.statMembers') : t('home.statYears') },
          { value: '10+', label: t('home.statYears') },
        ].slice(0, 3).map((s, i) => (
          <div key={i} style={{ textAlign: 'center', padding: '1.5rem' }} data-testid={`stat-${i}`}>
            <div style={{ fontSize: '2.5rem', fontWeight: '700', color: 'var(--brand)', fontFamily: 'var(--font-heading)' }}>{s.value}</div>
            <div style={{ color: 'var(--muted)', fontSize: '0.9rem' }}>{s.label}</div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default Home;
